import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'btn-cell-rendererQxMatrix',
    template: `
    <button mat-mini-fab color="primary" pTooltip="{{ 'Edit' | translate }}" tooltipPosition="top" (click)="onEditClick()">
        <mat-icon>edit</mat-icon>
    </button>
    <button mat-mini-fab color="warn" pTooltip="{{ 'Delete' | translate }}" tooltipPosition="top" (click)="onDeleteClick()">
        <mat-icon>delete</mat-icon>
    </button>
`
})
// tslint:disable-next-line:component-class-suffix
export class BtnCellRendererQxMatrix implements ICellRendererAngularComp, OnDestroy {
    private params: any;
    private onEditClickCallback: Function;
    private onDeleteClickCallback: Function;
    refresh(params: any): boolean {
        throw new Error('Method not implemented.');
    }
    agInit(params: any): void {
        this.params = params;
        this.onEditClickCallback = params.onEditClick;
        this.onDeleteClickCallback = params.onDeleteClick;
    }

    onEditClick(): void {
        if (this.onEditClickCallback instanceof Function) {
            this.onEditClickCallback(this.params.node.data.Map_Id);
        }
    }

    onDeleteClick(): void {
        if (this.onDeleteClickCallback instanceof Function) {
            this.onDeleteClickCallback(this.params.node.data.Map_Id);
        }
    }
    ngOnDestroy(): any {
        // no need to remove the button click handler
        // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
    }
}
